import type { TImageElement } from "platejs";
import { type PlateElementProps, PlateElement } from "platejs/react";
import { memo } from "react";
import { cn } from "../../tailwind-utils";

export const ImageElement = memo(function ImageElement(
  props: PlateElementProps<TImageElement>,
) {
  const { url, width } = props.element;
  const cssWidth =
    typeof width === "string" || typeof width === "number" ? width : undefined;

  return (
    <PlateElement {...props} className="py-1">
      <img
        alt=""
        className={cn("block max-w-full rounded-sm", "cursor-default")}
        draggable={false}
        src={url}
        style={
          cssWidth
            ? { width: cssWidth, maxHeight: 400 }
            : { width: "auto", maxHeight: 400 }
        }
      />
      {props.children}
    </PlateElement>
  );
});
